export default {
  list: {
    pageTitle: {
      fullList: '全部商品',
      myShop:'我的商店',
    },
    containerTitle: {
      hotsale: '熱門產品',
      hotsalePackage:"熱門團購",
      myProduct:'我的產品',
      myHotsalePackage:"我的團購"
    },
    addBtnHint1:'凡是選購過的商品都會自動成為你專屬商店的商品',
    addBtnHint2:'趕快去首頁選購吧！ ',
    loadMore:'加載更多',
    selectSuccess:'成功添加該商品至精選推介',
    removeConfirm:'確認從精選推介移除該商品嗎？ ',
    noMoreProduct:'－已顯示所有貨物－'
  },
  detail: {
    shippingCost: '運費 $ 28 及附加關稅',
    containerTitle: {
      description: '商品詳情',
      feature: '商品特色'
    }
  },

}


// WEBPACK FOOTER //
// ./src/Product/langs/zh_hk/index.js